const QUEST_SERIES_ACHIEVEMENTS = {
  lostMasterclasser: [
    'dilatoryDistress1',
    'dilatoryDistress2',
    'dilatoryDistress3',
    'mayhemMistiflying1',
    'mayhemMistiflying2',
    'mayhemMistiflying3',
    'stoikalmCalamity1',
    'stoikalmCalamity2',
    'stoikalmCalamity3',
    'taskwoodsTerror1',
    'taskwoodsTerror2',
    'taskwoodsTerror3',
    'lostMasterclasser1',
    'lostMasterclasser2',
    'lostMasterclasser3',
    'lostMasterclasser4',
  ],
  bareNecessities: [
    'monkey',
    'sloth',
    'treeling',
  ],
  bugBonanza: [
    'beetle',
    'butterfly',
    'snail',
    'spider',
  ],
  freshwaterFriends: [
    'axolotl',
    'frog',
    'hippo',
  ],
  justAddWater: [
    'octopus',
    'dilatory_derby',
    'kraken',
    'whale',
    'turtle',
    'nudibranch',
    'seaserpent',
    'dolphin',
  ],
  mindOverMatter: [
    'rock',
    'slime',
    'yarn',
  ],
  seasonalSpecialist: [
    'egg',
    'evilsanta',
    'evilsanta2',
  ],
};

export default QUEST_SERIES_ACHIEVEMENTS;
